import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import React, { MutableRefObject } from "react";
import { IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { FilterOption } from "../FilterPopover.types.ts";
import { useTranslation } from "@localization/useTranslation.ts";
import { TextFieldWrapper } from "../FilterPopover.tsx";

export interface TextFieldSubMenuProps {
    selectedOption?: FilterOption;
    onChange: (value: string) => void;
    onLeftArrowClick?: () => void;
    submenuInputRef?: MutableRefObject<HTMLTextAreaElement | undefined>;
    onApply?: (value: string) => void;
}

function TextFieldSubMenu(props: TextFieldSubMenuProps) {
    const { onChange, onLeftArrowClick, submenuInputRef, onApply } = props;
    const { translateString } = useTranslation();

    const value = props.selectedOption?.value as string;

    return (
        <TextFieldWrapper>
            <DotLegalTextField
                label={translateString("text")}
                value={value ?? null}
                debounce={false}
                onChange={(value) => onChange(value)}
                inputRef={submenuInputRef}
                onEnterPressed={() => onApply?.(value ?? "")}
                endAdorment={
                    value ? (
                        // preventDefault on mousedown keeps the caret in the field, so clearing
                        // leaves the user ready to type instead of having to click back in
                        <IconButton
                            onClick={() => onChange("")}
                            onMouseDown={(event) => event.preventDefault()}
                            sx={{ color: "primary.main", padding: 0.5 }}
                            size="small"
                            aria-label={translateString("remove")}
                        >
                            <ClearIcon sx={{ width: 16, height: 16 }} />
                        </IconButton>
                    ) : undefined
                }
                noMargin
            />
        </TextFieldWrapper>
    );
}

export default TextFieldSubMenu;
